import ReplayCarousel from './ReplayCarousel';

export default ReplayCarousel;
